import React from 'react'
import styled, { css } from 'styled-components'
import { IconType } from './Icon.types'
import iconMap from './iconMap'

export const IconStyles = css`
	display: inline-flex;
	align-items: center;
	position: relative;
	width: 2.3em;
	svg {
		display: block;
		position: relative;
		width: 100%;
		height: auto;
	}
`

const IconView = styled.i`
	${IconStyles}
`

export type IconProps = {
	type: IconType
	className?: string
}

export const Icon = ({ type, className }: IconProps) => {
	const LibIcon = iconMap[type as 'logo']
	const IconForRender = LibIcon || iconMap.logo
	return (
		<IconView className={`icon ${type}${className ? ` ${className}` : ''}`}>
			<IconForRender />
		</IconView>
	)
}
